export function maskEmail(email) {
  const atIndex = email.indexOf('@');
  if (atIndex !== -1) {
    const username = email.substring(0, atIndex);
    const maskedUsername = username.substring(0, 1) + '*'.repeat(username.length - 1);
    return maskedUsername + email.substring(atIndex);
  }
  return email;
}
export function maskMobile(phoneNumber) {
  // Extract the first two digits and the last three digits
  const firstTwoDigits = phoneNumber.slice(0, 3); // + and the first two digits
  const lastThreeDigits = phoneNumber.slice(-3);

  // Create the masked part for the middle digits
  const middleMaskedPart = phoneNumber.slice(3, -3).replace(/[0-9]/g, 'X');

  // Combine the parts together
  return firstTwoDigits + middleMaskedPart + lastThreeDigits;
}

export function hasEmptyKey(obj) {
  for (let key in obj) {
    if (
      obj[key] === '' ||
      obj[key] === null ||
      (obj[key] === undefined && key != 'isMainAddress' && key != 'addressType')
    ) {
      return true;
    }
  }
  return false;
}
